module.exports = __webpack_public_path__ + "static/img/机器人_icon.a549f2db.png";